import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VehicleInfo'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VehicleInfoStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VehicleInfoStore",
			variables: true,
		})
	}
}

export async function load_VehicleInfo(params) {
  await initClient()

	const store = new VehicleInfoStore()

	await store.fetch(params)

	return {
		VehicleInfo: store,
	}
}
